import { render } from "./ColorRenderer.vue?vue&type=template&id=3794214a&scoped=true"
const script = {}

import "./ColorRenderer.vue?vue&type=style&index=0&id=3794214a&lang=scss&scoped=true"

import exportComponent from "/web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3794214a"]])

export default __exports__